{
  "close": "Uždaryti"
}
